import React from 'react';
import CargomaticModal from 'components/v2/modal';
import CustomersAPIUtils from 'utils/CustomersAPIUtils';
import { useTranslation } from 'react-i18next';
const InviteConsigneeModal = ({ consignee, onHideModal }) => {
    const { t } = useTranslation();
    const inviteConsignee = async () => {
        await CustomersAPIUtils.inviteConsignee(consignee);
        onHideModal();
    };
    const renderBody = () => {
        return (React.createElement("div", { className: "block" },
            React.createElement("div", { className: "text-lg" },
                t('INVITE_CONFIRMATION'),
                React.createElement("span", { className: "font-semibold" },
                    " ", consignee === null || consignee === void 0 ? void 0 :
                    consignee.first_name),
                " ?"),
            React.createElement("div", { className: "pt-3" },
                t('EMAIL_SENT_TO'),
                React.createElement("span", { className: "font-semibold" },
                    " ", consignee === null || consignee === void 0 ? void 0 :
                    consignee.email,
                    " "),
                "!")));
    };
    const renderFooter = () => {
        return (React.createElement("div", { className: "flex items-center justify-end" },
            React.createElement("button", { className: "button button-secondary pr-3", onClick: onHideModal }, t('CANCEL')),
            React.createElement("button", { className: "button button-green", onClick: inviteConsignee }, t('INVITE'))));
    };
    return (React.createElement(CargomaticModal, { backdrop: "static", onHide: onHideModal, body: renderBody(), footer: renderFooter(), title: t('INVITE_CONSIGNEE'), style: { top: '30%' } }));
};
export default InviteConsigneeModal;
